import React from "react";

const common = {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.9,
  strokeLinecap: "round",
  strokeLinejoin: "round",
};

export default function AppIcon({ name = "spark", className = "icon" }) {
  const n = String(name || "").toLowerCase();

  switch (n) {
    case "status":
      return (
        <svg viewBox="0 0 24 24" className={className} {...common}>
          <path d="M4 19h16" />
          <path d="M7 16V9" />
          <path d="M12 16V5" />
          <path d="M17 16v-3" />
        </svg>
      );
    case "upload":
      return (
        <svg viewBox="0 0 24 24" className={className} {...common}>
          <path d="M12 16V4" />
          <path d="m7 9 5-5 5 5" />
          <path d="M5 20h14" />
        </svg>
      );
    case "notifications":
    case "bell":
      return (
        <svg viewBox="0 0 24 24" className={className} {...common}>
          <path d="M15 18a3 3 0 1 1-6 0" />
          <path d="M18 16v-4a6 6 0 1 0-12 0v4l-2 2h16z" />
        </svg>
      );
    case "charts":
      return (
        <svg viewBox="0 0 24 24" className={className} {...common}>
          <path d="M4 19h16" />
          <path d="M7 15l3-3 3 2 4-6" />
          <path d="m15 8 2-.2-.2 2" />
        </svg>
      );
    case "audit":
      return (
        <svg viewBox="0 0 24 24" className={className} {...common}>
          <path d="M12 3l7 3v6c0 5-3.5 7.5-7 9-3.5-1.5-7-4-7-9V6z" />
          <path d="m9.5 12 1.7 1.7 3.8-4.2" />
        </svg>
      );
    case "usage":
      return (
        <svg viewBox="0 0 24 24" className={className} {...common}>
          <rect x="4" y="5" width="16" height="14" rx="4" />
          <path d="M8 9h.01" />
          <path d="M12 9h4" />
          <path d="M8 13h.01" />
          <path d="M12 13h4" />
          <path d="M8 17h8" />
          <path d="M17.5 5v3" />
          <path d="M20 10h-3" />
        </svg>
      );
    case "retrieve":
      return (
        <svg viewBox="0 0 24 24" className={className} {...common}>
          <path d="M12 5v10" />
          <path d="m8 11 4 4 4-4" />
          <path d="M5 19h14" />
        </svg>
      );
    case "kpi":
      return (
        <svg viewBox="0 0 24 24" className={className} {...common}>
          <path d="M12 13 7 8" />
          <path d="M12 13l5-5" />
          <path d="M12 13v7" />
          <circle cx="12" cy="13" r="8" />
        </svg>
      );
    case "vendors":
    case "materials":
      return (
        <svg viewBox="0 0 24 24" className={className} {...common}>
          <path d="M3 7.5 12 3l9 4.5-9 4.5z" />
          <path d="M3 12l9 4.5 9-4.5" />
          <path d="M3 16.5 12 21l9-4.5" />
        </svg>
      );
    case "users":
      return (
        <svg viewBox="0 0 24 24" className={className} {...common}>
          <circle cx="9" cy="8" r="3" />
          <path d="M3.5 18c1.2-2.7 3.4-4 5.5-4s4.3 1.3 5.5 4" />
          <path d="M16.5 10.5a2.5 2.5 0 1 0 0-5" />
          <path d="M16 14c2 0 3.6 1.1 4.5 3" />
        </svg>
      );
    case "user":
      return (
        <svg viewBox="0 0 24 24" className={className} {...common}>
          <circle cx="12" cy="8" r="3.5" />
          <path d="M5 19c1.4-3 3.9-4.5 7-4.5S17.6 16 19 19" />
        </svg>
      );
    case "settings":
      return (
        <svg viewBox="0 0 24 24" className={className} {...common}>
          <circle cx="12" cy="12" r="3" />
          <path d="M19.4 15a1 1 0 0 0 .2 1.1l.1.1a2 2 0 0 1-2.8 2.8l-.1-.1a1 1 0 0 0-1.1-.2 1 1 0 0 0-.6.9V20a2 2 0 0 1-4 0v-.2a1 1 0 0 0-.7-.9 1 1 0 0 0-1.1.2l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1 1 0 0 0 .2-1.1 1 1 0 0 0-.9-.6H4a2 2 0 0 1 0-4h.2a1 1 0 0 0 .9-.7 1 1 0 0 0-.2-1.1l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1 1 0 0 0 1.1.2 1 1 0 0 0 .6-.9V4a2 2 0 0 1 4 0v.2a1 1 0 0 0 .7.9 1 1 0 0 0 1.1-.2l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1 1 0 0 0-.2 1.1 1 1 0 0 0 .9.6h.2a2 2 0 0 1 0 4h-.2a1 1 0 0 0-.9.7Z" />
        </svg>
      );
    case "orgs":
    case "building":
      return (
        <svg viewBox="0 0 24 24" className={className} {...common}>
          <path d="M4 21h16" />
          <path d="M7 21V7l5-3 5 3v14" />
          <path d="M10 11h1" />
          <path d="M13 11h1" />
          <path d="M10 14h1" />
          <path d="M13 14h1" />
        </svg>
      );
    case "review":
    case "approval":
      return (
        <svg viewBox="0 0 24 24" className={className} {...common}>
          <path d="M9 12.5 11 14.5 15.5 10" />
          <path d="M7 4h10l3 3v13H4V4z" />
        </svg>
      );
    case "coa":
    case "document":
      return (
        <svg viewBox="0 0 24 24" className={className} {...common}>
          <path d="M7 3h7l5 5v13H7z" />
          <path d="M14 3v5h5" />
          <path d="M10 13h6" />
          <path d="M10 17h6" />
        </svg>
      );
    case "logout":
      return (
        <svg viewBox="0 0 24 24" className={className} {...common}>
          <path d="M10 17v2a2 2 0 0 0 2 2h6V3h-6a2 2 0 0 0-2 2v2" />
          <path d="M15 12H3" />
          <path d="m6 9-3 3 3 3" />
        </svg>
      );
    case "info":
      return (
        <svg viewBox="0 0 24 24" className={className} {...common}>
          <circle cx="12" cy="12" r="9" />
          <path d="M12 10v6" />
          <path d="M12 7.5h.01" />
        </svg>
      );
    case "eye":
    case "preview":
      return (
        <svg viewBox="0 0 24 24" className={className} {...common}>
          <path d="M2.5 12s3.5-6 9.5-6 9.5 6 9.5 6-3.5 6-9.5 6-9.5-6-9.5-6Z" />
          <circle cx="12" cy="12" r="2.5" />
        </svg>
      );
    case "close":
      return (
        <svg viewBox="0 0 24 24" className={className} {...common}>
          <path d="M6 6l12 12" />
          <path d="M18 6 6 18" />
        </svg>
      );
    case "chevron-left":
      return (
        <svg viewBox="0 0 24 24" className={className} {...common}>
          <path d="m15 18-6-6 6-6" />
        </svg>
      );
    case "chevron-right":
      return (
        <svg viewBox="0 0 24 24" className={className} {...common}>
          <path d="m9 18 6-6-6-6" />
        </svg>
      );
    case "spark":
    default:
      return (
        <svg viewBox="0 0 24 24" className={className} {...common}>
          <path d="m12 3 1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8Z" />
        </svg>
      );
  }
}
